let newPostsPerPage, currentPage,
    postsPerPage = $('.show-more-posts').attr('data-postsperpage'),
    filterSelect = $('.blog-filters__select'),
    blogList = $(".blog-list"),
    blogAuthorList = $(".blog-author-list"),
    blogListContainer = $('.blog-list-container'),
    dataPostType = $('.blog-hero-block').attr('data-post-type'),
    filterForm;

filterSelect.minimalect();

function blogFilterSubmit() {
	let blogFilterData = filterForm.serialize();
	const $btnMore = $('.show-more-posts')
	const $btnMoreText = $btnMore.find("span");
	let btnText = "";
	newPostsPerPage = $btnMore.attr('data-postsperpage');
	$.ajax({
		type: "POST",
		url: themeVars.ajax_url,
		data: {
			action: "postsLoad",
			data: blogFilterData,
			postType: dataPostType,
			postsPerPage: newPostsPerPage,
		},
		beforeSend: function () {
			btnText = $btnMoreText.text();
			$btnMoreText.text('Loading...');
		},
		success: function (response) {
			$btnMoreText.text(btnText);

			blogListContainer.fadeOut(function () {
				blogListContainer.html(response);
				blogListContainer.fadeIn();

				if (parseInt(newPostsPerPage) >= $('.blog-list').children().length) {
					$('.show-more-posts').hide();
				} else {
					$('.show-more-posts').show();
				}
				if (
					blogList
					.children()
					.hasClass("no-posts")
				) {
					blogList.css("display", "block");
				}
			});

		},
		complete: function () {
			const newUrl = window.location.href.replace(/\/page\/[0-9]?/, '');
			window.history.pushState({}, "", newUrl);
		},
	});
}

function blogFilterSubmitLoadMore() {
    const $btnMore = $('.show-more-posts')
    const $btnMoreText = $btnMore.find("span");
    let btnText = "";
    newPostsPerPage = $btnMore.attr('data-postsperpage');
    currentPage = $btnMore.attr('data-page');

	const data = {
		query: JSON.stringify( window.themeVarsEnv ),
		page: currentPage,
	};

    $.ajax({
        type: "POST",
        url: themeVars.ajax_url,
        data: {
            action: "postsLoadMore",
            data: data,
        },
        beforeSend: function () {
            btnText = $btnMoreText.text();
            $btnMoreText.text('Loading...');
        },
        success: function (response) {
            $btnMoreText.text(btnText);

        const maxPages = parseInt($btnMore.attr('data-max-pages'));

            blogListContainer.fadeOut(function () {
                blogListContainer.find('.blog-list').append(response);
                blogListContainer.fadeIn();
                if ( parseInt(currentPage) - 1 === maxPages ) {
                    $btnMore.hide(); // if last page, remove the button
                }
                if (
                    blogList
                        .children()
                        .hasClass("no-posts")
                ) {
                    blogList.css("display", "block");
                }
            });
        },
        complete: function () {
            if (currentPage) {
                const currentURL = window.location.href;
                let newURL;
                const regex = /\/page\/[0-9]?/;
                if (regex.test(currentURL)) {
                    newURL = currentURL.replace(regex, '/page/' + currentPage);
                } else {
                    newURL = currentURL + 'page/' + currentPage + '/';
                }
                window.history.pushState({}, "", newURL);
                currentPage = parseInt(currentPage) + 1;
                $btnMore.attr('data-page', currentPage);
            }
        },
    });
}
if ($(document).width() > 768) {
    filterForm = $('#blog-filters-tax-tablet');
} else {
    filterForm = $("#blog-filters-tax");
}

$(document).on('resize', function () {
    if ($(document).width() > 768) {
        filterForm = $('#blog-filters-tax-tablet');
    } else {
        filterForm = $("#blog-filters-tax");
    }
});

filterSelect.change(function () {
    filterForm = $("#blog-filters-tax");
    filterForm.submit(blogFilterSubmit());
});

$(document).on('click', '.show-more-posts', function () {
    filterForm.submit(blogFilterSubmitLoadMore());
});
if (parseInt(postsPerPage) >= $('.blog-list').children().length) {
    $('.show-more-posts').hide();
}

function loadAuthorPosts() {
    const $btnMore = $('.show-more-author-posts');
    const $btnMoreText = $btnMore.find("span");
    let btnText = "";
    newPostsPerPage = $btnMore.attr('data-postsperpage');
    let authorId = $btnMore.attr('data-author');
    $.ajax({
        type: "POST",
        url: themeVars.ajax_url,
        data: {
            action: "postsAuthorLoad",
            postsPerPage: newPostsPerPage,
            authorId: authorId,
        },
        beforeSend: function () {
            btnText = $btnMoreText.text();
            $btnMoreText.text('Loading...');
        },
        success: function (response) {
            $btnMoreText.text(btnText);

            blogAuthorList.fadeOut(function () {
                blogAuthorList.html(response);
                blogAuthorList.fadeIn();
                if (parseInt(newPostsPerPage) >= $('.blog-list').children('.post-card').length) {
                    $btnMore.hide();
                } else {
                    $btnMore.show();
                }
                if (
                    blogList
                        .children()
                        .hasClass("no-posts")
                ) {
                    blogList.css("display", "block");
                }
            });

        },
    });
}

$(document).on('click', '.show-more-author-posts', function () {
    postsPerPage = $('.show-more-author-posts').attr('data-postsperpage');
    newPostsPerPage = $('.show-more-author-posts').attr('data-postsperpage', parseInt(postsPerPage) + 2);
    loadAuthorPosts();
});



// WEBPACK FOOTER //
// ./scripts/modules/blog.js